import { useResponsiveStyleWrapper } from '@bingads-webui-campaign-react/unified-app-shared';

const IndicatorWidth = 10;
const IndicatorsGap = 8;

const getIndicatorsWidth = placements => (placements * IndicatorWidth) + ((placements - 1) * IndicatorsGap);

export const getAssetStepStyles = () => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '32px',

    '& .title-item': {
      width: 'unset !important',
    },
  },
  'container-l': {
    width: 'calc(100% - 64px)',
  },
  imageExperience: {
    '& .image-experience-content': {
      minWidth: 'unset !important',
    },
  },
  formContainer: {
    width: '100%',
    '& .text-assets-collection-container': {
      width: 'auto',
    },
    '& .asset-group-name-section .error-string-wrapper': {
      right: 'unset !important',
      position: 'unset !important',
    },

    '& .text-input-container': {
      width: '100%',
    },
    '& .date-settings table': {
      width: 'unset !important',
    },
  },
  'formContainer-xxl': {
    width: '530px',
  },
  'formContainer-xl': {
    width: '430px',
  },
  previewerContainer: {
    marginTop: 150,
    '& > div': {
      top: 124,
    },
    flexGrow: '1',
  },
  'previewerContainer-l': {
    width: 'calc(100% - 64px)',
  },
  'previewerContainer-m': {
    width: 'calc(100% - 64px)',
  },
  'previewerContainer-s': {
    width: 'calc(100% - 64px)',
  },
  adPreview: {
    '& .new-preview-carousel-container-adprelib': {
      maxWidth: '550px !important',
    },
    marginTop: '140px',
  },
  windowsAdPreview: {
    position: 'sticky',
    width: 420,
    marginTop: '140px',
    top: '0px',
    '& .ad-placement-preview': {
      height: 450,
    },
    '& .new-preview-carousel-container-adprelib': {
      // backgroundColor: '#ffffff',
      border: '1px solid #C8C8C8 !important',
      // borderRadius: '4px',
      // boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
      // maxWidth: '420px',
      minWidth: 'unset !important',

      '& .preview-string': {
        display: 'none',
      },

      '& .ad-preview-actions': {
        display: 'flex',
      },
      '& .carousel-inner': {
        height: 450,
      },

      '& .carousel-indicators': {
        display: 'flex',
        gap: '8px',
        left: '50% !important',
        margin: '48px 0 !important',
        transform: 'translateX(-50%)',

        '& li': {
          margin: '0',
        },
      },

      '& .carousel-control': {
        display: 'flex',
        width: '12px',
        margin: '12px 0 !important',
        left: '50% !important',
      },

      '& .carousel-control.left': {
        transform: ({ placements }) => {
          const transformations = [];

          // Move left arrow to the center
          transformations.push('translateX(-50%)');

          // Move left arrow to the left of the indicators
          const indicatorsWidth = getIndicatorsWidth(placements);
          transformations.push(`translateX(-${indicatorsWidth / 2}px)`);

          // Add extra space between the left arrow and the indicators
          transformations.push('translateX(-47px)');

          return transformations.join(' ');
        },
        bottom: 16,
      },

      '& .carousel-control.right': {
        transform: ({ placements }) => {
          const transformations = [];

          // Move right arrow to the center
          transformations.push('translateX(-50%)');

          // Move right arrow to the right of the indicators
          const indicatorsWidth = getIndicatorsWidth(placements);
          transformations.push(`translateX(${indicatorsWidth / 2}px)`);

          // Add extra space between the right arrow and the indicators
          transformations.push('translateX(43px)');

          return transformations.join(' ');
        },
        bottom: 16,
      },

      '& .ad-preview-title': {
        height: '24px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

        '& .preview-title-string-key': {
          color: '#323130',
          fontSize: '14px',
          fontWeight: 700,
          marginRight: '8px',
        },

        '& .preview-title-preview-type': {
          fontSize: '14px',
        },
      },

      '& .ad-placement-preview': {
        overflow: 'hidden',

        '& .card-parent': {
          width: '100%',
        },

        '& .responsive-ad-preview-content': {
          boxSizing: 'border-box',
          width: '100%',
        },
      },
      '& .ad-placement-preview.app-ad-windows': {
        '& .card-parent': {
          '& .responsive-ad-preview-content': {
            height: 'fit-content',
            width: 'fit-content',
            maxWidth: '100%',
            '& .text-container-apl': {
              maxWidth: 'calc(100% - 25px)',
            },
          },
        },
      },
      '& .ad-placement-preview.app-ad-start-menu': {
        '& .new-responsive-ad-preview-container': {
          height: '100%',
          width: '100%',
        },
      },
    },
  },
  'windowsAdPreview-xxl': {
    '@media (min-width: 1400px)': {
      width: 530,
    },
    width: 420,
  },
  'windowsAdPreview-xl': {
    width: 420,
  },
});

export const useAssetsStepStyles = () => useResponsiveStyleWrapper(getAssetStepStyles);
